export const STATUS = {
  PASSED: 'passed',
  FAILED: 'failed',
}

export const SCANNER_MUTE_BACKFILL_REASON = 'Muted by the cloud scanner before mute tracking existed'
